import * as React from 'react';
import {
  Box,
  Cards,
  Container,
  ProgressBar,
  SpaceBetween,
  Spinner
} from '@cloudscape-design/components';
import { DocumentContext } from '../../context/documentContext';
import { useContext } from 'react';

export const FileProcessing = () => {
  const { filesToUpload } = useContext(DocumentContext);
  const loadIndicator = (value: string) => {
    if (value === 'Analyzing Document') {
      return (
        <SpaceBetween size="l" direction="horizontal">
          <Box>Analysing Document</Box>
          <Spinner></Spinner>
        </SpaceBetween>
      );
    }
    if (value === 'Document Analyzed') {
      return (
        <SpaceBetween size="l" direction="horizontal">
          <Box>Analysis Complete</Box>
          <ProgressBar status="success" />
        </SpaceBetween>
      );
    }
  };

  return (
    <Container>
      {filesToUpload.length > 0 ? (
        <Cards
          cardsPerRow={[{ cards: 1 }]}
          items={filesToUpload}
          cardDefinition={{
            header: (item) => item.name,
            sections: [
              {
                id: 'uploaded',
                header: 'Document Status',
                content: (item) => loadIndicator(item.uploaded)
              }
            ]
          }}
        ></Cards>
      ) : null}
    </Container>
  );
};
